export class RoleChangeCommand{
    userId:string;
    newRole:string;

    constructor(userID:string,newrole:string){
        this.userId = userID;
        this.newRole = newrole;
    }
}